import React from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import { updateShowChat } from '../../../redux/slices/ui/layout';
import ChatFiveNine from '../../ChatFiveNine';
import ErrorIcon from '../../../assets/external/logo-something-went-wrong.svg';
import { ROUTES } from '../../Routes';

import {
  Container,
  Image,
  SectionTitle,
  SectionBody,
  ChatButton,
  HomeButton
} from './Styles';
import MixpanelService from '../../../services/MixpanelService';
import mixpanelConfig from '../../../_shared/constants/mixpanelConfig';

const SupportText = ({ userAuthenticated }) => {
  if (userAuthenticated) {
    return <span>Here are some helpful links.</span>;
  }

  return (
    <span>
      Reach out to support at&nbsp;
      <a href="mailto:support@traderev.com">support@traderev.com</a>&nbsp;for
      any questions.
    </span>
  );
};

const ErrorUi = () => {
  const dispatch = useDispatch();
  const userAuthenticated = useSelector(
    state => state?.auth?.user,
    shallowEqual
  );
  const mixpanel = MixpanelService.get();

  const navigateToHomePage = () => {
    mixpanel.track(mixpanelConfig.names.clickHomePageError);
    window.location.href = ROUTES.TR4_ENDPOINT;
  };

  const displayChatWidget = () => {
    mixpanel.track(mixpanelConfig.names.clickDisplayChatError);
    dispatch(updateShowChat(true));
  };

  return (
    <>
      <Container userAuthenticated={userAuthenticated}>
        <Image src={ErrorIcon} />
        <SectionTitle>Something went wrong.</SectionTitle>
        <SectionBody>
          <span>Not to worry, this should be fixed soon.</span>
          <br />
          <SupportText userAuthenticated={userAuthenticated} />
        </SectionBody>
        {userAuthenticated && (
          <div>
            <ChatButton onClick={displayChatWidget}>
              CHAT WITH SUPPORT
            </ChatButton>
            <HomeButton onClick={navigateToHomePage}>
              BACK TO HOME PAGE
            </HomeButton>
          </div>
        )}
      </Container>
      <ChatFiveNine />
    </>
  );
};

export default ErrorUi;
